// extracted by mini-css-extract-plugin
module.exports = {"video-clipped-box":"how-to-get_video-clipped-box__CWF7O"};